import axios from 'axios';

const axiosEncodedConfig = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    timeout: 10000, // Set a timeout for requests
});

const pendingRequests = new Map();

// Request Interceptor
axiosEncodedConfig.interceptors.request.use(
    (config) => {
        const requestIdentifier = `${config.url}_${config.method}`;
        if (pendingRequests.has(requestIdentifier)) {
            const cancelTokenSource = pendingRequests.get(requestIdentifier);
            cancelTokenSource.cancel('Cancelled due to new request');
        }
        const newCancelTokenSource = axios.CancelToken.source();
        config.cancelToken = newCancelTokenSource.token;
        pendingRequests.set(requestIdentifier, newCancelTokenSource);

        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
axiosEncodedConfig.interceptors.response.use(
    (response) => {
        const requestIdentifier = `${response.config.url}_${response.config.method}`;
        pendingRequests.delete(requestIdentifier);
        return response;
    },
    (error) => {
        if (axios.isCancel(error)) {
            console.warn('Request canceled:', error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosEncodedConfig;